import { LineItemSupplier } from "elephant-web/gql";

export const SUPPLIER_LABELS: Record<LineItemSupplier, string> = {
  [LineItemSupplier.Government]: "Government",
  [LineItemSupplier.Private]: "Private",
};

// Falls back to the raw value so a future enum member never renders a blank
// label before its human label is added here.
export const supplierLabel = (supplier: LineItemSupplier): string =>
  SUPPLIER_LABELS[supplier] ?? supplier;

export const SUPPLIER_OPTIONS = (
  Object.values(LineItemSupplier) as LineItemSupplier[]
).map((value) => ({ value, label: supplierLabel(value) }));
